import { Component, inject, input, OnInit, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../core/utils";
import { ConfirmationModalComponent, DataTableComponent } from "../../../shared/components";
import { Constants } from "../../../shared/constants/constants";
import { TableButtonClicked } from "../../../shared/models";
import { AttributesApiService, SystemLayoutService } from "../../../shared/services";

@Component({
  selector: "adaa-attributes-list",
  imports: [DataTableComponent],
  templateUrl: "./attributes-list.html",
  styleUrl: "./attributes-list.scss",
})
export class AttributesListComponent implements OnInit {
  private readonly _translateService = inject(TranslateService);
  private readonly _toastrService = inject(ToastrService);
  private readonly _modalService = inject(NgbModal);
  private readonly _attributesApiService = inject(AttributesApiService);
  private readonly _router = inject(Router);
  private readonly _systemLayoutService = inject(SystemLayoutService);

  private readonly _untilDestroyed = AdaaHelper.untilDestroyed();
  readonly Constants = Constants;
  readonly breadcrumb = input.required<string>();
  readonly adaaDataTable = viewChild.required<DataTableComponent>("adaaDataTable");

  public ngOnInit(): void {
    this._systemLayoutService.hasActiveEntityChanged$
      .pipe(this._untilDestroyed())
      .subscribe(() => this._router.navigateByUrl("/console"));
  }

  public getAction(value: TableButtonClicked) {
    switch (value.event) {
      case "view":
        this._router.navigateByUrl(`/console/attributes/${value.data.id}`);
        break;
      case "edit":
        this._router.navigateByUrl(`/console/attributes/edit/${value.data.id}`);
        break;
      case "delete":
        this._deleteAttribute(value.data.id);
        break;

      default:
        break;
    }
  }

  public addNew() {
    this._router.navigateByUrl("/console/attributes/create");
  }

  private _deleteAttribute(id: number) {
    const modal = this._modalService.open(ConfirmationModalComponent, {
      centered: true,
      size: "md",
    });

    modal.componentInstance.header = "attributes.create.delete_yes_no_title";
    modal.componentInstance.title = "attributes.create.delete_yes_no_information";
    modal.componentInstance.subTitle = "common.form.label.using_item_delete";

    modal.result.then((e) => {
      if (e) {
        this._attributesApiService.deleteAttribute(id).subscribe({
          next: () => {
            this._toastrService.success(this._translateService.instant("notification.success.remove"));
            this.adaaDataTable().loadTableData();
          },
        });
      }
    });
  }
}
